import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../../providers/AppDataProvider';

export class ActivityTierBenefitsDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== 'adminGetTierDistribution')
      return Promise.reject(new Error('Unsupported resource'));

    const { page = 1, perPage = 10 } = params.pagination || {};
    const { filter = {}, meta = {} } = params;
    const sort = JSON.stringify(params.sort);

    // 构建查询参数
    const searchParams = new URLSearchParams({
      sort,
      page: page.toString(),
      size: perPage.toString(),
      query: JSON.stringify(filter),
      ...meta,
    });

    // 构建请求 URL
    const url = `${baseUrl}/activity/adminGetTierDistribution?${searchParams.toString()}`;

    try {
      const { json } = await httpClient(url);

      // 根据您的数据结构处理数据
      // 这里假设您的 API 返回格式可能不同，需要特殊处理
      let rows: any[] = [];
      let total = 0;

      // 根据实际 API 响应结构调整
      if (json?.data) {
        rows = json.data;
      } else if (json?.tasks) {
        rows = json.tasks;
      } else if (Array.isArray(json)) {
        rows = json;
      } else {
        // 默认处理
        rows = json?.list ?? json?.items ?? json?.records ?? [];
      }
      total = rows.length;
      //data 按照创建时间倒序
      rows.sort((a, b) => {
        const dateA = new Date(a.tierLevel || 0).getTime();
        const dateB = new Date(b.tierLevel || 0).getTime();
        return dateA - dateB;
      });
      // 确保每条记录都有 id
      const data = rows.map((r: any, i: number) =>
        r?.id != null ? r : { id: `${i}`, ...r }
      );

      return { data, total };
    } catch (error) {
      console.error('ActivityTasksDataProvider getList error:', error);
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async create(resource: string, params: any): Promise<any> {
    // 仅拦截 activity/tasks 列表对应的创建
    if (resource !== 'adminGetTierDistribution')
      return Promise.reject(new Error('Unsupported resource'));


    return { data:{} };
  }

  // eslint-disable-next-line class-methods-use-this
  async update(resource: string, params: any): Promise<any> {
    if (resource !== 'adminGetTierDistribution')
      return Promise.reject(new Error('Unsupported resource'));
    return { data: {} };
  }

  // eslint-disable-next-line class-methods-use-this
  async delete(resource: string, params: any): Promise<any> {
    if (resource !== 'adminGetTierDistribution')
      return Promise.reject(new Error('Unsupported resource'));

    return { data: {} };
  }
}

// 创建实例并导出
export const activityTierBenefitsDataProvider = new ActivityTierBenefitsDataProvider();
